type MuiButtonType = { [k: string]: any };

const MuiButton: MuiButtonType = {};

export default MuiButton;
